window.filteredList = new Object();
// set defaults, these can be overriden in the page
filteredList.persistSearch = true;
filteredList.clearText = locale.get("Clear");

filteredList.Initialize = function (filterTarget) {
    if (typeof (filteredList.enabled) != 'undefined' && filteredList.enabled) {
        $(filterTarget).each(function () {
            var list = $(this);

            // check if listbox already has search field added to it
            if (list.prev() && list.prev().attr("class") == 'filterBox')
                return;

            var storedSearch = eval('filteredList.search_' + list.attr('id'));

            // define elements
            var wrapEl = $('<table class="filterInputWrapper"></table>');
            wrapEl.append('<tr><td style="position:relative;padding:0;margin:0;width:180px;height: 22px;overflow: hidden;"/></tr>');
            var inputField = $("<input type='text' style='font-size:12px;padding: 2px 20px 2px 2px;border: 1px solid #CCC;padding: 2px 20px 2px 2px;line-height: 14px;width: 150px;margin: 0;'/>").bind('keyup', function () { filteredList.textChanged(this, list); });
            inputField.addClass("textbox");

            var clearLink = $('<img src="icons/clear-left.png" title="' + filteredList.clearText + '" style="position: relative;margin-left: -24px;margin-top: 0px;top: 3px;cursor:pointer;"/>').bind('click', function () {
                if (typeof (storedSearch) != 'undefined')
                    eval('filteredList.search_' + list.attr('id') + '="";');
                filteredList.clearSearch(inputField, list);
            });
            clearLink.addClass("clear");
            var clearFloat = $("<div/>").addClass("floatClear");

            // cache initial list
            eval("filteredList." + $(this).attr('id') + "=$(this).find('option');");

            // build up a layout
            if (!$(list).prev().hasClass('filterInputWrapper')) {
                wrapEl.find('td').append(inputField).append(clearLink).append(clearFloat);
                list.before(wrapEl);
            }

            // if persisting state through callbacks, fill input text field and run filter
            if (filteredList.persistSearch && typeof (storedSearch != 'undefined')) {
                inputField.val(storedSearch);
                filteredList.textChanged(inputField, list);
            }
        });
    }
};

filteredList.textChanged = function (elem, list) {
    // clear listbox
    $(list).find('option').remove();
    // fetch cached items and filter string
    var options = eval('filteredList.' + $(list).attr('id'));
    var searchString = $(elem).val();

    // if persisting through callbacks, store search field
    if (filteredList.persistSearch)
        eval('filteredList.search_' + $(list).attr('id') + '=$(elem).val();');



    // add all elements that satisfy a filter to the listbox
    options.each(function () {
        if ($(this).text().toLowerCase().indexOf(searchString.toLowerCase()) > -1) {
            $(list).append($(this));
        }
    });

    /* ie 8/9 bug */
    $(list).hide();
    $(list).show();

    // if list is empty and it shouldn't be, put the default element back in
    if ($(list).find('option').length == 0) {
        $(list).append(options.filter('[value="0"]'));
    }
};

filteredList.clearSearch = function (elem, list) {
    $(elem).val('');
    filteredList.textChanged(elem, list);
};

$().ready(function () { filteredList.Initialize(); });
if (typeof (Sys) != 'undefined' && Sys.WebForms.PageRequestManager.getInstance() != null)
    Sys.WebForms.PageRequestManager.getInstance().add_endRequest(function () { filteredList.Initialize(); });

